import { stringify } from 'query-string';

import { useAuth } from '@dashboard/context/AuthContext/AuthContext';
import { fetchInfinite, fetcher } from '@dashboard/services/request';

async function getInfiniteSubscriptions(sellerId, query, token) {
  const res = await fetchInfinite(`/sellers/${sellerId}/subscriptions?${stringify(query)}`, token);

  return res;
}

async function getSubscriptions(sellerId, query, token) {
  const res = await fetcher(`/sellers/${sellerId}/subscriptions?${stringify(query)}`, token);

  return res;
}

export default function useSubscriptionQueries() {
  const { token } = useAuth();

  return {
    getInfiniteSubscriptions: (sellerId, query) => getInfiniteSubscriptions(sellerId, query, token),
    getSubscriptions: (sellerId, query) => getSubscriptions(sellerId, query, token),
  };
}
